<script setup lang="ts">
import { useTranslate } from "addeus-common-library/stores/translate";
import ImageHeader from "../../../components/website/ImageHeader.vue";
import DiscoverNavigation from "../../../components/website/DiscoverNavigation.vue";
import Title from "../../../components/website/LayoutTitleSection.vue";
import Footer from "../../../components/website/Footer.vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { useSeoMeta } from "../../../composables/useSeoMeta";

// Import images
import header from "../../../assets/image/discover/history/discover-history-header.jpg";
import iconHeader from "../../../assets/image/discover/icon-discover-title.svg";
import ImageTeam from "../../../assets/image/discover/history/discover-history-weAre.jpg";
import signature from "../../../assets/image/discover/history/signature.png";
import icon1 from "../../../assets/image/discover/history/discover-history-icon1.svg";
import icon2 from "../../../assets/image/discover/history/discover-history-icon2.svg";
import icon3 from "../../../assets/image/discover/history/discover-history-icon3.svg";
import icon4 from "../../../assets/image/discover/history/discover-history-icon4.svg";
import ImageTimeline1997 from "../../../assets/image/discover/history/discover-history-timeline-1.jpg";
import ImageTimeline1998 from "../../../assets/image/discover/history/discover-history-timeline-2.jpg";
import ImageTimeline2001 from "../../../assets/image/discover/history/discover-history-timeline-3.jpg";
import ImageTimeline2002 from "../../../assets/image/discover/history/discover-history-timeline-4.jpg";
import ImageTimeline2005 from "../../../assets/image/discover/history/discover-history-timeline-5.jpg";
import ImageTimeline2007 from "../../../assets/image/discover/history/discover-history-timeline-6.jpg";
import ImageTimeline2009 from "../../../assets/image/discover/history/discover-history-timeline-7.jpg";
import ImageTimeline2011 from "../../../assets/image/discover/history/discover-history-timeline-8.jpg";
import ImageTimeline2012 from "../../../assets/image/discover/history/discover-history-timeline-9.jpg";
import ImageTimeline2013 from "../../../assets/image/discover/history/discover-history-timeline-10.jpg";
import ImageTimeline2014 from "../../../assets/image/discover/history/discover-history-timeline-11.jpg";
import ImageTimeline2015 from "../../../assets/image/discover/history/discover-history-timeline-12.jpg";
import ImageTimeline2016 from "../../../assets/image/discover/history/discover-history-timeline-13.jpg";
import ImageTimeline2020 from "../../../assets/image/discover/history/discover-history-timeline-14.jpg";
import ImageTimeline2022 from "../../../assets/image/discover/history/discover-history-timeline-15.jpg";
import ImageTimeline2023 from "../../../assets/image/discover/history/discover-history-timeline-16.jpg";
/// ///
const breakpoints = useBreakpoints(breakpointsTailwind);

const isSmallerThanXl = breakpoints.smallerOrEqual("xl");
const isSmallerThanMd = breakpoints.smallerOrEqual("md");
const isBetweenLg = breakpoints.between("lg", "xl");
const { setTranslateNamespace } = useTranslate();
setTranslateNamespace(".discover.history");

useSeoMeta({
    title: "Fabricant de karting électrique indoor depuis 1997",
    description:
        "Speed2Max, premier fabricant français de karts électriques depuis 1997. 75 pistes équipées, 1500 karts produits, expertise en conception de pistes et formation de personnel. Basé à Clermont-Ferrand.",
    path: "/discover/history",
    breadcrumbs: [
        { name: "Accueil", path: "/" },
        { name: "Découvrir", path: "/discover/history" },
        { name: "Notre histoire", path: "/discover/history" },
    ],
});
</script>

<template>
    <VFlex flex-direction="column">
        <DiscoverNavigation current="history"></DiscoverNavigation>
        <ImageHeader>
            <template #image>
                <img :src="header" alt="découvrir Speed2max" />
            </template>
            <template #title>
                <div><Translate path=".titleP1"></Translate>&nbsp;</div>
                <div class="has-text-primary">
                    <Translate path=".titleP2"></Translate>
                </div>
            </template>

            <template #icon>
                <img :src="iconHeader" alt="S2M licence de marque icone" />
            </template>
        </ImageHeader>
        <VFlex flex-direction="column" class="has-background-white py-6">
            <TranslateNamespace path=".whoAreWe">
                <VFlex
                    :flex-direction="isSmallerThanXl ? 'column' : 'row'"
                    align-items="stretch"
                    row-gap="3rem"
                    column-gap="3rem"
                    class="px-6 py-5">
                    <div class="has-text-dark is-size-6 w-100">
                        <Title third>
                            <template #titleP1>
                                <Translate path=".titleP1"></Translate
                            ></template>
                            <template #titleP2>
                                <Translate path=".titleP2"></Translate
                            ></template>
                        </Title>
                        <div class="mb-2 is-weight-600">
                            <Translate path=".content1"></Translate>
                        </div>
                        <div class="mb-2"><Translate path=".content2"></Translate></div>
                        <div class="mb-2"><Translate path=".content3"></Translate></div>
                        <div class="mb-5"><Translate path=".content4"></Translate></div>
                        <div class="mb-2 is-weight-600">
                            <Translate path=".signature1"></Translate>
                        </div>
                        <div class="mb-2"><Translate path=".signature2"></Translate></div>
                        <div class="mb-2"><Translate path=".signature3"></Translate></div>
                        <img :src="signature" alt="signature" class="img-signature" />
                    </div>
                    <div class="w-100 img-team"></div>
                </VFlex>
            </TranslateNamespace>
            <TranslateNamespace path=".infoS2m">
                <VFlex
                    :flex-direction="isSmallerThanXl ? 'column' : 'row'"
                    justify-content="center"
                    align-items="center"
                    row-gap="3rem"
                    column-gap="3rem"
                    class="p-6">
                    <VFlex
                        :flex-direction="isSmallerThanMd ? 'column' : 'row'"
                        row-gap="2rem"
                        column-gap="2rem">
                        <div class="has-text-dark has-text-centered bloc-icon-history">
                            <img
                                :src="icon1"
                                alt="icone piste"
                                class="icon-history mb-3" />
                            <div class="is-size-4 is-weight-700">
                                <Translate path=".numberTrack"></Translate>
                            </div>
                            <div
                                class="is-size-5 is-uppercase subtitle-icon is-weight-500">
                                <Translate path=".titleTrack"></Translate>
                            </div>
                        </div>
                        <div class="has-text-dark has-text-centered bloc-icon-history">
                            <img
                                :src="icon2"
                                alt="icone kart"
                                class="icon-history mb-3" />
                            <div class="is-size-4 is-weight-700">
                                <Translate path=".numberKart"></Translate>
                            </div>
                            <div
                                class="is-size-5 is-uppercase subtitle-icon is-weight-500">
                                <Translate path=".titleKart"></Translate>
                            </div>
                        </div>
                    </VFlex>
                    <VFlex
                        :flex-direction="isSmallerThanMd ? 'column' : 'row'"
                        row-gap="2rem"
                        column-gap="2rem">
                        <div class="has-text-dark has-text-centered bloc-icon-history">
                            <img
                                :src="icon3"
                                alt="icone pilotes"
                                class="icon-history mb-3" />
                            <div class="is-size-4 is-weight-700">
                                <Translate path=".numberPilot"></Translate>
                            </div>
                            <div
                                class="is-size-5 is-uppercase subtitle-icon is-weight-500">
                                <Translate path=".titlePilot"></Translate>
                            </div>
                        </div>
                        <div class="has-text-dark has-text-centered bloc-icon-history">
                            <img
                                :src="icon4"
                                alt="icone collaborateur"
                                class="icon-history mb-3" />
                            <div class="is-size-4 is-weight-700">
                                <Translate path=".numberCollaborator"></Translate>
                            </div>
                            <div
                                class="is-size-5 is-uppercase subtitle-icon is-weight-500">
                                <Translate path=".titleCollaborator"></Translate>
                            </div>
                        </div>
                    </VFlex>
                </VFlex>
            </TranslateNamespace>
            <TranslateNamespace path=".timeline">
                <Title>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <VFlex
                    flex-direction="column"
                    gap-row="2rem"
                    align-items="center"
                    column-gap="2rem"
                    class="px-6 py-5">
                    <div
                        class="has-text-dark has-text-centered is-size-5 is-weight-600 mb-6">
                        <Translate path=".content"></Translate>
                    </div>
                    <!-- L - 1997 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text1"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline1997" alt="1997" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                1997
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 1997 -->
                    <!-- R - 1998 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline1998" alt="1998" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                1998
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline">
                            <Translate path=".text2"></Translate>
                        </div>
                    </VFlex>
                    <!-- R - 1998 -->
                    <!-- L - 2001 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text3"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline2001" alt="2001" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                2001
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 2001 -->
                    <!-- R - 2002 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline2002" alt="2002" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                2002
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline">
                            <Translate path=".text4"></Translate>
                        </div>
                    </VFlex>
                    <!-- R - 2002 -->
                    <!-- L - 2005 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text5"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline2005" alt="2005" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                2005
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 2005 -->
                    <!-- R - 2007 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline2007" alt="2007" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                2007
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline">
                            <Translate path=".text6"></Translate>
                        </div>
                    </VFlex>
                    <!-- R - 2007 -->
                    <!-- L - 2009 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text7"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline2009" alt="2009" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                2009
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 2009 -->
                    <!-- R - 2011 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline2011" alt="2011" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                2011
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline">
                            <Translate path=".text8"></Translate>
                        </div>
                    </VFlex>
                    <!-- R - 2011 -->
                    <!-- L - 2012 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text9"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline2012" alt="2012" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                2012
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 2012 -->
                    <!-- R - 2013 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline2013" alt="2013" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                2013
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline">
                            <Translate path=".text10"></Translate>
                        </div>
                    </VFlex>
                    <!-- R - 2013 -->
                    <!-- L - 2014 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text11"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline2014" alt="2014" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                2014
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 2014 -->
                    <!-- R - 2015 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline2015" alt="2015" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                2015
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline order-text-1">
                            <div class="mb-2 is-weight-600">
                                <Translate path=".text12"></Translate>
                            </div>
                            <div class="mb-2">
                                <Translate path=".text121"></Translate>
                            </div>
                            <div class="mb-2">
                                <Translate path=".text122"></Translate>
                            </div>
                            <div class="mb-2">
                                <Translate path=".text123"></Translate>
                            </div>
                            <div class="is-weight-600">
                                <Translate path=".text124"></Translate>
                            </div>
                        </div>
                    </VFlex>
                    <!-- R - 2015 -->
                    <!-- L - 2016 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text13"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline2016" alt="2016" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                2016
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 2016 -->
                    <!-- R - 2020 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline2020" alt="2020" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                2020
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline">
                            <Translate path=".text14"></Translate>
                        </div>
                    </VFlex>
                    <!-- R - 2020 -->
                    <!-- L - 2022 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div
                            class="has-text-dark has-text-right is-size-6 w-text-timeline order-text-1">
                            <Translate path=".text15"></Translate>
                        </div>
                        <div class="img-timeline position-relative order-image-1">
                            <img :src="ImageTimeline2022" alt="2022" />
                            <div class="timeline-year-right has-text-dark is-weight-900">
                                2022
                            </div>
                        </div>
                    </VFlex>
                    <!-- L - 2022 -->
                    <!-- R - 2023 -->
                    <VFlex
                        :flex-direction="
                            isBetweenLg ? 'column' : isSmallerThanMd ? 'column' : 'row'
                        "
                        gap-row="2rem"
                        align-items="center"
                        column-gap="2rem"
                        class="my-6">
                        <div class="img-timeline position-relative">
                            <img :src="ImageTimeline2023" alt="2023" />
                            <div class="timeline-year-left has-text-dark is-weight-900">
                                2023
                            </div>
                        </div>
                        <div class="has-text-dark is-size-6 w-text-timeline">
                            <div class="mb-2 is-weight-600">
                                <Translate path=".text16"></Translate>
                            </div>
                            <div>
                                <Translate path=".text161"></Translate>
                            </div>
                        </div>
                    </VFlex>
                    <!-- R - 2023 -->
                </VFlex>
            </TranslateNamespace>
        </VFlex>
        <Footer></Footer>
    </VFlex>
</template>
<style scoped lang="scss">
@use "sass:color";

.w-100 {
    width: 100%;
}

.w-text-timeline {
    max-width: 450px;
    line-height: 1.6;
}

.position-relative {
    position: relative;
}

.timeline-year-right {
    position: absolute;
    font-family: "Bebas Neue";
    font-size: 8rem;
    top: -80px;
    left: -100px;
    text-shadow: 1px 0 $primary, -1px 0 $primary, 0 1px $primary, 0 -1px $primary,
        1px 1px $primary, -1px -1px $primary, 1px -1px $primary, -1px 1px $primary;
}

.timeline-year-left {
    position: absolute;
    font-family: "Bebas Neue";
    font-size: 8rem;
    top: -80px;
    right: -100px;
    text-shadow: 1px 0 $primary, -1px 0 $primary, 0 1px $primary, 0 -1px $primary,
        1px 1px $primary, -1px -1px $primary, 1px -1px $primary, -1px 1px $primary;
}

.img-timeline {
    /* stylelint-disable-next-line function-url-quotes */
    // background-image: v-bind("`url('${ImageTimeline1997}')`");
    > img {
        border-radius: 5px;
        max-width: 450px;
    }
}

@media (max-width: 1280px) and (min-width: 1024px) {
    .timeline-year-right {
        left: 25%;
    }

    .timeline-year-left {
        right: 25%;
    }

    .order-text-1 {
        order: 2;
        text-align: left !important;
    }

    .order-image-1 {
        order: 1;
    }

    .w-text-timeline {
        margin-top: 1.5rem;
    }
}

@media (max-width: 768px) {
    .timeline-year-right {
        left: 25%;
    }

    .timeline-year-left {
        right: 25%;
    }

    .order-text-1 {
        order: 2;
        text-align: left !important;
    }

    .order-image-1 {
        order: 1;
    }

    .w-text-timeline {
        margin-top: 1.5rem;
    }
}

@media (max-width: 535px) {
    .img-timeline {
        > img {
            max-width: 250px;
        }
    }
}

.title-section {
    padding: 1.5rem 0 !important;
}

.img-signature {
    max-width: 200px;
    margin-top: 2rem;
}

.img-team {
    border-radius: 5px;
    background-image: v-bind("`url('${ImageTeam}')`");
    background-size: cover;
    background-position: center;
    min-height: 350px;
}

.bloc-icon-history {
    line-height: 1.4;

    .icon-history {
        height: 70px;
    }

    .subtitle-icon {
        letter-spacing: 0.3rem;
        max-width: 250px;
    }
}
</style>
